webpackJsonp([91],{

/***/ 1266:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FilterList__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_mixins__ = __webpack_require__(56);




var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.params.page = page;
						_context.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/channels', { params: this.params });

					case 3:
						response = _context.sent;

						this.rows = response.data.data;
						this.numberPage = response.data.meta ? response.data.meta.pagination.total_pages : 1;

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

var deleteRow = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref6) {
		var id = _ref6.id;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.delete('//pms.controlinn.com/api' + '/channels/' + id);

					case 2:
						this.showNotification('La OTA ha sido eliminada.', 'success');
						this.loadData();

					case 4:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function deleteRow(_x2) {
		return _ref5.apply(this, arguments);
	};
}();

var updateState = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref8) {
		var id = _ref8.id;
		var newRow;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						newRow = this.rows.find(function (row) {
							return row.id === id;
						});

						delete newRow.companies;
						delete newRow.id;
						_context3.next = 5;
						return this.$http.put('//pms.controlinn.com/api' + '/channels/' + id, newRow);

					case 5:
						this.showNotification('El estado de la OTA se actualizó correctamente.', 'success');

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function updateState(_x3) {
		return _ref7.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function created() {
	this.loadData();
}

function columnSortableEvent(_ref) {
	var id = _ref.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.params.sortField = newColumn[0].code;
	this.params.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadData();
}

function selectedFilter(_ref3) {
	var value = _ref3.value;

	if (value === 1) {
		this.params.flagActive = null;
	} else if (value === 3) {
		this.params.flagActive = 0;
	} else {
		this.params.flagActive = 1;
	}
	this.filterValue = value;
	this.loadData();
}

function editChannel(_ref4) {
	var id = _ref4.id;

	this.$router.push({ name: 'channels-config', params: { channelId: id } });
}

function pagesVisible() {
	return this.numberPage < 5 ? this.numberPage : 5;
}

function searchChannel(search) {
	this.params.search = search;
	this.loadData();
}

/* harmony default export */ __webpack_exports__["default"] = ({
	created: created,
	name: 'channels-list',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_4__components_shared_ButtonCreate___default.a,
		FilterList: __WEBPACK_IMPORTED_MODULE_5__components_shared_FilterList___default.a,
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	computed: {
		pagesVisible: pagesVisible
	},
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } }],
			filterValue: 1,
			href: { name: 'channels-new' },
			numberPage: 1,
			params: {
				flagActive: null,
				page: 1,
				perPage: 10,
				search: null,
				sortDirection: null,
				sortField: null
			},
			rows: []
		};
	},

	methods: {
		columnSortableEvent: columnSortableEvent,
		selectedFilter: selectedFilter,
		loadData: loadData,
		editChannel: editChannel,
		deleteRow: deleteRow,
		searchChannel: searchChannel,
		updateState: updateState
	},
	mixins: __WEBPACK_IMPORTED_MODULE_6__shared_mixins__["a" /* default */]
});

/***/ }),

/***/ 1588:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md10": ""
    }
  }, [_c('filter-list', {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.filterValue
    },
    on: {
      "selected-filter": _vm.selectedFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "md2": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": 'Agregar extranet',
      "href": _vm.href
    }
  })], 1)], 1), _vm._v(" "), _c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "selectable": false,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": true,
      "include-switch": true,
      "include-settings": true,
      "switch-value": 'flagActive',
      "include-delete-single": true
    },
    on: {
      "go-to-edit-page": _vm.editChannel,
      "on-delete-event": _vm.deleteRow,
      "on-sortable-event": _vm.columnSortableEvent,
      "on-search-event": _vm.searchChannel,
      "on-change-state": _vm.updateState
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.numberPage,
      "total-visible": _vm.pagesVisible
    },
    on: {
      "input": function($event) {
        _vm.loadData(_vm.params.page)
      }
    },
    model: {
      value: (_vm.params.page),
      callback: function($$v) {
        _vm.params.page = $$v
      },
      expression: "params.page"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1266),
  /* template */
  __webpack_require__(1588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/91.494e310af6c640ac476c.js